<template>
    <div>
        <b-card no-body>
            <b-card-body class="p-0">
                <b-row align-h="end" class="px-3 mb-2">
                    <b-button variant="blue-button" class="me-2" @click="shouldShowFilters = !shouldShowFilters">
                        <span style="white-space: nowrap">
                            {{ $translate('filters') }}
                            <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                }`"></b-icon>
                        </span>
                    </b-button>
                    <b-button variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                        :title="$translate('reset_filters')">
                        <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                    </b-button>
                </b-row>
                <HistoryItemsQueryFilter class="mt-3" v-show="shouldShowFilters" :officer-option="officerOption"
                    :locations="locations" :orderTypes="orderTypes" :officers="users" ref="queryFilter" v-model="filters" />
                <b-table striped hover responsive :items="transactions" :fields="fields" :busy="tableLoading">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <!-- <strong>{{ $translate('loading') }}</strong> -->
                        </div>
                    </template>
                    <template #cell(location_section)="{ item }">
                        <div v-html="getInventoryLocation(item)"></div>
                    </template>

                    <template #cell(activity_type)="{ item }">
                        <div>
                            {{
                                (
                                    orderTypes.find(
                                        x => item.order.order_type_id == x.id
                                    ) || {}
                                ).name
                            }}
                        </div>
                    </template>
                    <template #cell(activity)="{ item }">
                        <div>
                            <b-link :to="`/ams/activities/${item.order.id}`">
                                {{ item.order.reference_no }}</b-link>
                        </div>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import HistoryItemsQueryFilter from '@/views/InventoryTransfer/HistoryItemsQueryFilter'
export default {
    name: 'itemInventory',
    components: { HistoryItemsQueryFilter },
    props: ['totalQty', 'tableLoading'],
    data() {
        return {
            shouldShowFilters: false,
            filters: {
                product_search: null,
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                fromDate: null,
                toDate: null,
            }
        }
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('id') },
                {
                    key: 'location_section',
                    label: this.$translate('locations'),
                },
                {
                    key: 'datetime',
                    label: this.$translate('date_time'),
                    formatter: (value, key, item) =>
                        new Date(item.sortedTime).toLocaleDateString() +
                        ' ' +
                        new Date(item.sortedTime).toLocaleTimeString(),
                },
                {
                    key: 'added_amount',
                    label: this.$translate('movements'),
                },
                {
                    key: 'activity_type',
                    label: this.$translate('activity_type'),
                },
                {
                    key: 'activity',
                    label: this.$translate('activity'),
                }

                // // 'activity_type',
                // 'activity',
            ]
        },
        officerOption() {
            return '----officers----'
        },
        orderTypes() {
            return this.$store.state.orderType.items
        },
        users() {
            return this.$store.getters['users/sorted_officers']
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse || x.sections.some(y => !y.is_officer)
            )
        },

        transactions() {
            let trxs = this.$store.getters['masterItem/sections'] || []
            trxs = trxs.reduce(
                (
                    _trxs,
                    { transactions, location_section, quantity_on_hand }
                ) => {
                    const new_trans = transactions.map(x => {
                        x.location_section = location_section
                        x.quantity_on_hand = quantity_on_hand
                        x.sortedTime = new Date(x.created_at).getTime()
                        return x
                    })
                    _trxs.push(...new_trans)
                    return this.historyFilterdData(_trxs)
                },
                []
            )
            trxs.sort((a, b) => b.sortedTime - a.sortedTime)
            return trxs
        },
    },

    methods: {
        historyFilterdData(historydata) {
            console.log("historydata")
            //filter out non warehouses
            const {
                fromDate,
                toDate,
                location_id,
                officer_id,
                order_item_type_id,
            } = this.filters
            console.log("this.filters", this.filters)

            let data = [...(historydata || [])].filter(
                x =>
                    !x.location_section ||
                    x.location_section.is_officer ||
                    x.location_section.officers.length ||
                    x.location_section.location.is_warehouse
            )
            if (parseInt(location_id, 10)) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        x.location_section.location.id == location_id &&
                        x.location_section.location.is_warehouse &&
                        x.location_section.officers.length == 0
                )
            }

            if (location_id === this.officerOption) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        (x.location_section.is_officer ||
                            x.location_section.officers.length)
                )
            }
            if (officer_id) {
                data = data.filter(
                    x =>
                        x.location_section &&
                        x.location_section.officers[0] &&
                        x.location_section.officers[0].id == officer_id
                )
            }
            if (order_item_type_id) {
                data = data.filter(x => x.order.order_type_id == order_item_type_id)
            }
            if (fromDate && toDate) {
                data = data.filter(x => new Date(x.created_at) >= new Date(fromDate) && new Date(x.created_at) <= new Date(toDate))
            }
            return data
        },
        getInventoryLocation({ location_section, quantity_on_hand }) {
            console.log('location_section', location_section)
            if (!location_section) {
                return ''
            }

            if (location_section.officers.length) {
                return (
                    `<strong>${this.$translate('officer')}</strong>: ` +
                    (location_section.officers[0] &&
                        location_section.officers[0].first_name +
                        ' ' +
                        location_section.officers[0].last_name) +
                    '(' +
                    quantity_on_hand +
                    ')'
                )
            } else if (location_section.location.is_warehouse) {
                return (
                    location_section.location.name +
                    `:` +
                    location_section.name +
                    '(' +
                    quantity_on_hand +
                    ')'
                )
            } else {
                return 'Customer Location'
            }
        },
        resetFilters() {
            this.filters = {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                fromDate: null,
                toDate: null,
            }
        }
    },
}
</script>